import React from 'react'
import MobileFormContainer from '../../templates/mobileForm/MobileFormContainer'
import MobileFormLayout from '../../templates/mobileForm/MobileFormLayout'

export default class MobileFormPage extends React.Component {
  render() {
    const { portalID } = this.props.match.params
    if (portalID) {
      return (
        <MobileFormLayout>
          <MobileFormContainer portalID={portalID} />
        </MobileFormLayout>
      )
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/mobile/MobileFormPage.js